import { Button, Typography, Stack, SxProps } from "@mui/material";

import { formatDate, formatTime } from "@/formatter";
import { now } from "@/lib/dateTime";

import type { ButtonProps, StackProps } from "@mui/material";
import type { MouseEventHandler } from "react";
import type { Schedule } from "@/models";

export type BookingButtonProps = {
  data: Schedule;
  onClick: MouseEventHandler;
};

export function BookingButton({
  data,
  onClick,
  typographySx,
  stackProps,
  ...props
}: BookingButtonProps &
  Omit<ButtonProps, "onClick"> & {
    typographySx?: SxProps;
    stackProps?: StackProps;
  }) {
  const { joinedAt, isBooked } = data;
  const canJoin = joinedAt ? !isBooked && now() > joinedAt : !isBooked;
  const canBooking = joinedAt && now() < joinedAt;
  return (
    <Stack width="100%" alignItems="center" {...stackProps}>
      <Button
        variant="contained"
        disabled={!canJoin}
        fullWidth
        onClick={onClick}
        {...props}
      >
        {canBooking ? "เปิดจองเร็วๆนี้" : isBooked ? "จองแล้ว" : "จอง"}
      </Button>
      {canBooking && (
        <Typography
          color="primary.main"
          mt={1}
          fontSize="0.75rem"
          sx={typographySx}
        >
          *เปิดจองวันที่ {formatDate(joinedAt)} เวลา {formatTime(joinedAt)}
        </Typography>
      )}
    </Stack>
  );
}
